module.exports = __webpack_public_path__ + "assets/img/板块化分析.f3aa5f9f.png";